import { useMemo } from 'react';
import { getPrimaryMedia, useStorageUrls } from './storageMedia';

export function getCompactCollectibleImagePath(record = {}) {
  const media = getPrimaryMedia(record);
  return String(
    media?.variants?.image200?.storagePath
    || media?.variants?.image1000?.storagePath
    || media?.storagePath
    || ''
  ).trim();
}

export function getCollectibleDisplayImagePath(record = {}) {
  const media = getPrimaryMedia(record);
  return String(
    media?.variants?.image1000?.storagePath
    || media?.storagePath
    || ''
  ).trim();
}

export function getCollectiblePlaybackPath(record = {}) {
  const media = getPrimaryMedia(record);
  return String(
    media?.variants?.playback?.storagePath
    || media?.playbackStoragePath
    || ''
  ).trim();
}

export function getCollectiblePosterPath(record = {}) {
  return getCollectibleDisplayImagePath(record);
}

export function useCompactCollectibleImageUrl(record = {}) {
  const imagePath = getCompactCollectibleImagePath(record);
  const urls = useStorageUrls([imagePath]);
  return useMemo(() => urls[imagePath] || '', [imagePath, urls]);
}

export function getCollectibleSoundtrackPath(record = {}) {
  const media = getPrimaryMedia(record);
  return String(
    record?.soundtrack?.storagePath
    || media?.soundtrack?.storagePath
    || media?.soundtrackStoragePath
    || ''
  ).trim();
}

export function isVideoCollectibleMedia(record = {}) {
  const media = getPrimaryMedia(record);
  return String(media?.type || '').trim() === 'video_collectible';
}

export function isCollectibleMediaReady(entry = {}) {
  const media = Array.isArray(entry?.media) ? entry.media[0] || null : null;
  const soundtrackPath = getCollectibleSoundtrackPath(entry);
  if (!media) return false;
  if (String(media?.type || '') !== 'video_collectible') {
    return Boolean(String(media?.storagePath || '').trim());
  }
  return String(media?.processing?.status || '') === 'ready'
    && Boolean(getCollectibleDisplayImagePath({ media: [media] }))
    && Boolean(getCollectiblePlaybackPath({ media: [media] }))
    && Boolean(soundtrackPath)
    && String(entry?.soundtrack?.processing?.status || media?.soundtrack?.processing?.status || '') === 'ready';
}

export function useCollectibleMediaUrls(record = {}) {
  const displayPath = getCollectibleDisplayImagePath(record);
  const playbackPath = getCollectiblePlaybackPath(record);
  const posterPath = getCollectiblePosterPath(record);
  const soundtrackPath = getCollectibleSoundtrackPath(record);
  const urls = useStorageUrls([displayPath, playbackPath, posterPath, soundtrackPath]);
  return useMemo(() => ({
    mediaUrl: urls[displayPath] || '',
    playbackUrl: urls[playbackPath] || '',
    posterUrl: urls[posterPath] || '',
    soundtrackUrl: urls[soundtrackPath] || '',
  }), [displayPath, playbackPath, posterPath, soundtrackPath, urls]);
}
